import {
  GET_CHAT_GPT_SUMMARY,
  CLEAR_CHAT_GPT_SUMMARY,
  PENDING_CHAT_GPT_SUMMARY,

  // GET_CHAT_GPT_SUMMARY_NODE,
  // CLEAR_CHAT_GPT_SUMMARY_NODE,
  // PENDING_CHAT_GPT_SUMMARY_NODE,
  GET_CHAT_GPT_HISTORY_NODE,
  CLEAR_CHAT_GPT_HISTORY_NODE,
  PENDING_CHAT_GPT_HISTORY_NODE,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  chat_gpt_summary: false,
  response_pending: false,
  chat_gpt_history: [],
  history_response_pending: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PENDING_CHAT_GPT_SUMMARY:
      return {
        ...state,
        response_pending: true
      }
    case GET_CHAT_GPT_SUMMARY:
      return {
        ...state,
        chat_gpt_summary: action.payload,
        response_pending: false
      }
    case PENDING_CHAT_GPT_HISTORY_NODE:
      return {
        ...state,
        history_response_pending: true
      }
    case GET_CHAT_GPT_HISTORY_NODE:
      return {
        ...state,
        chat_gpt_history: action.payload,
        history_response_pending: false
      }
    case CLEAR_CHAT_GPT_SUMMARY:
      return {
        ...state,
        ...initialState
      }
    case CLEAR_CHAT_GPT_HISTORY_NODE:
      return {
        ...state,
        chat_gpt_history: [],
        history_response_pending: false
      }
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState
      }
    default:
      return state;
  }
}
